import { render, staticRenderFns } from "./EmployeeInformationForm.vue?vue&type=template&id=2348ce29&"
import script from "./EmployeeInformationForm.vue?vue&type=script&lang=ts&"
export * from "./EmployeeInformationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports